import whyDidYouRender from '@welldone-software/why-did-you-render';
import React, { Suspense, lazy } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { AppContainerStyle } from './AppContainer.styles';
import { Loading } from '../common/ipc-components/Loading';
import { PublicLayout } from '../public/PublicLayout';
import { httpOnlySecurityService } from '../../externals/iam';
import { PublicArea } from '../public/PublicArea';

if (process.env.NODE_ENV !== 'production') {
  whyDidYouRender(React);
}

const StyledAppContainer = styled.div`
  ${AppContainerStyle}
`;
StyledAppContainer.displayName = 'StyledAppContainer';
const LazyPrivateArea = lazy(() => import('./PrivateArea'));

const LoadingContainerStyled = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  background: #e4ecf3;
`;

function LoadingContainer() {
  return (
    <LoadingContainerStyled>
      <Loading loading />
    </LoadingContainerStyled>
  );
}

function PrivateAreaLoader() {
  return (
    <PublicLayout>
      <LoadingContainer />
    </PublicLayout>
  );
}

function PrivateArea() {
  return (
    <Suspense fallback={<PrivateAreaLoader />}>
      <LazyPrivateArea />
    </Suspense>
  );
}
const GlobalStyle = createGlobalStyle`  
  #root, body, html {
    margin:0; padding: 0;
    height: 100%;
  }
`;

export const AppContainerComponent = () => (
  <>
    <GlobalStyle />
    <StyledAppContainer>
      {httpOnlySecurityService.isUserAuthenticated() ? (
        <PrivateArea />
      ) : (
        <PublicArea />
      )}
    </StyledAppContainer>
  </>
);

export default AppContainerComponent;
